


















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';
import Grid from '../../components/grid/Grid.vue';
import GridColumn from '../../components/grid/GridColumn.vue';
import FilterForm from '../donors/Filter.vue';
import Constants from '../../constants';
import { EventBus } from '../../event-bus';
import LrModal from '@/pages/donors/SendToLrModal.vue';
import printJS from 'print-js';
import Swal from 'sweetalert2';
import ExclusionFromWorkModal from './ExclusionFromWorkModal.vue';
import RouteHelper from "@/helpers/route.helper";
import FormHelper from '@/helpers/form.helper';

@Component({
  components: {
    'grid': Grid,
    'grid-column': GridColumn,
    'filter-form': FilterForm,
    'lr-modal': LrModal,
    'exclusion-from-work-modal': ExclusionFromWorkModal,
  },
})
export default class DonorsTab extends Vue {
  
  @Prop({ default: null })
  patient: any;

  findedDonors = [];
  totalCount = 0;
  currentPage = 0;
  pageSize = (window as any).pageSize;

  filter = {
    lrOrganizationId: null,
    externalId: null,
    donorStatus: null,
    operatorId: null,
    ageFrom: 18,
    ageTo: 65,
    coincidence: 10,
    gender: null,
    searchInDpb: false,
    rh: null,
    bloodType: null,
  } as any;

  isSearchCompleted = false;
  isOpenExclusionFromWorkModal = false;
  excludedDonorId = null;
  donorsToWorkIds = [];  

  showExclusionFromWorkModal(donorId: any) {
    this.isOpenExclusionFromWorkModal = true;
    this.excludedDonorId = donorId;
  }

  removeDonor(permanentRejectionReasonId: any) {    
    EventBus.$emit('showThrobber');
    axios.delete(`/donorsAtWork?id=${this.excludedDonorId}
                               &patientId=${this.patient.id}
                               &permanentRejectionReasonId=${permanentRejectionReasonId}`)
         .then(response => { 
                              EventBus.$emit('hideThrobber'); 
                              this.refreshGrids(); 
                           });
  }

  get exportUrl() {
    return (
      Constants.baseUrl +
      '/donors/ExportSearchResults?patientId=' +
      (this.patient && this.patient.id) +
      '&ageFrom=' +
      (this.filter && this.filter.ageFrom) +
      '&ageTo=' +
      (this.filter && this.filter.ageTo) +
      '&coincidence=' +
      (this.filter && this.filter.coincidence) +
      '&externalId=' +
      (this.filter && (this.filter.externalId || ''))
    );
  }

  get excludeFromWorkIsVisible() {
   return RouteHelper.isRouteNameAccessible(this.$auth.user(), "ExcludeDonorFromWork");
  }

  print() {
    printJS({
      printable: this.exportUrl,
      type: 'pdf',
      modalMessage: this.$t('Загрузка документа...') as string,
      showModal: true,
    });
  }

  onPageChange(currentPage: any)
  {
    this.currentPage = currentPage;
    this.searchDonors(this.filter);
  }

  onPageSizeChange(pageSize: any)
  {
    this.pageSize = pageSize;
    this.searchDonors(this.filter);
  }

  searchDonors(filterForm: any) {
    let fillFields = [];
    if (!this.patient.gender) {
      // @ts-ignore
      fillFields.push(this.$t('Пол'));
    }
    if(!FormHelper.hlaValidCount(this.patient.hlas)) {
      // @ts-ignore
      fillFields.push(this.$t('Минимум один локус'));
    }
    if(fillFields.length > 0) {
       Swal(this.$t('Нельзя начать поиск без указания полей') as string,
            `</br>  + ${fillFields.join("</br> ")}`,
        'warning'
      );
      return;
    }
     
    this.isSearchCompleted = true;
    this.filter = filterForm;
    EventBus.$emit('showThrobber');    
    let take = this.pageSize === 0 ? Constants.maxPageSize : this.pageSize;
    let skip = this.pageSize === 0 ? 0 : this.pageSize * this.currentPage;

    this.axios.get(
        '/donors', {
          params: {
            take,
            skip,
            patientId: this.patient.id,
            lrOrganizationId: this.filter.lrOrganizationId,
            externalId: this.filter.externalId,
            donorStatus: this.filter.donorStatus,
            operatorId: this.filter.operatorId,
            ageFrom: this.filter.ageFrom,
            ageTo: this.filter.ageTo,
            coincidence: this.filter.coincidence,
            gender: this.filter.gender,
            searchInDpb: this.filter.searchInDpb,
            rh: this.filter.rh,
            bloodType: this.filter.bloodType
          }
        }  
      )
      .then((response) => {
        this.findedDonors = response.data.rows;
        this.totalCount = response.data.totalCount;
        this.donorsToWorkIds.splice(0);
        EventBus.$emit('hideThrobber');
      })
      .catch((e) => {
        this.donorsToWorkIds.splice(0);
        EventBus.$emit('error', { msg: e.data.message });
      })
      .finally(() => {
        EventBus.$emit('hideThrobber');
      });;
  }

   resetFilter() {
    this.searchDonors({ lrOrganizationId: null, externalId: '', donorStatus: null, operatorId: null, searchInDpb: false, ageFrom: 18, ageTo: 65, coincidence: 10, gender: '', rh: '', bloodType: '' });
  }

  primarySearch(id: any) {
    this.patient.id = id;
    //@ts-ignore
    this.$refs.filterForm.resetForPatient();
  }

  refreshGrids() {
    this.donorsToWorkIds.splice(0);
    EventBus.$emit('showThrobber');
    this.axios
      .get(`/DonorsAtWork/GetForPatient?patientId=${this.patient.id}`)
      .then((response) => {
        this.$emit('refreshDonors');
        this.patient.donorsAtWork = response.data;
        EventBus.$emit('hideThrobber');
      })
      .catch((e) => {
        EventBus.$emit('error', { msg: e.data.message });
      })
      .finally(() => {
        EventBus.$emit('hideThrobber');
      });
    this.searchDonors(this.filter);
  }

  get idds() {
    return (
      this.findedDonors
        //@ts-ignore
        .filter((fd) => this.donorsToWorkIds.includes(fd.id))
        //@ts-ignore
        .map((fd) => fd.idd)
    );
  }
}
